import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useState, useEffect } from "react";

import Subheader from "components/Subheader";

import BecomeInternationalTcForm from "./components/BecomeInternationalTcForm";
import BecomeUsTcForm from "./components/BecomeUsTcForm";
import TechCommCards from "./components/TechCommModals";
import TechCommunitiesTable from "./components/TechCommunitiesTable";

export default function TechCommunities() {
  const [showUsTcModal, setShowUsTcModal] = useState(false);
  const [showInternationalTcModal, setShowInternationalTcModal] =
    useState(false);
  const handleShowUsTcModal = () => setShowUsTcModal(true);
  const handleShowInternationalTcModal = () =>
    setShowInternationalTcModal(true);

  useEffect(() => {
    document.title = "NIAP - Technical Communities";
  }, []);

  return (
    <>
      <Subheader pageName={"Technical Communities"} />

      <Container sx={{ py: 3 }} maxWidth="md">
        <Typography
          variant="h3"
          sx={{ textTransform: "uppercase", fontWeight: "bold", my: 3 }}
        >
          Protection Profiles - Technical Communities
        </Typography>

        <Typography variant="body1">
          The National Information Assurance Partnership (NIAP) is introducing
          an initiative to form Technical Communities (TCs) for the development
          of Protection Profiles (PPs). A key goal for the TCs is to ensure that
          PPs are generated as the result of collaboration between Government,
          industry, and academia.
        </Typography>

        <Typography variant="h6" my={3} fontWeight="bold">
          PARTICIPANTS
        </Typography>

        <Typography variant="body1">
          The Technical Communities are comprised of representatives from a
          broad range of affiliations such that the resultant PPs benefit from
          knowledge contributions that come from a variety of perspectives to
          produce effective and relevant technology content.
        </Typography>

        <Typography variant="body1" fontWeight="bold" mt={2}>
          The guiding principles of the organization (SC and TCs) are:
        </Typography>

        <Stack direction={{ xs: "column", md: "row" }} sx={{ mx: 3, mt: 1 }}>
          <Box flex={1}>
            <ul>
              <li>Consistency</li>
              <li>Transparency</li>
              <li>Collaboration</li>
              <li>Scalability</li>
            </ul>
          </Box>
          <Box flex={1}>
            <ul>
              <li>Improved &ldquo;Time to Market&rdquo;</li>
              <li>Leverages Industry Expertise</li>
              <li>International Participation</li>
              <li>Collective ownership of the process</li>
            </ul>
          </Box>
        </Stack>

        <Typography variant="body1">
          Calls for participants for each Technical Community (TC) are sent to
          industry, government, end users, academic institutions, and labs as
          announcements posted on the NIAP website. All interested parties
          wanting to participate in any TC should provide the following
          information to the aliases below:
        </Typography>

        <Stack direction={{ xs: "column", md: "row" }} sx={{ mx: 3, mt: 1 }}>
          <Box sx={{ flex: 1 }}>
            <ul>
              <li>Name</li>
              <li>
                Affiliation (Vendor/CCTL/ Academic Institution/Scheme/Other)
              </li>
              <li>Address</li>
            </ul>
          </Box>
          <Box sx={{ flex: 1 }}>
            <ul>
              <li>Telephone Number</li>
              <li>Email Address</li>
              <li>
                A brief statement of the qualifications for participation in the
                TC
              </li>
            </ul>
          </Box>
        </Stack>

        <TechCommCards />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          spacing={2}
          mt={5}
          mb={3}
        >
          <Button
            variant="contained"
            color="warning"
            sx={{
              borderRadius: "50px",
              fontWeight: "bold",
              p: 2,
            }}
            onClick={handleShowUsTcModal}
          >
            BECOME A US TECHNICAL COMMUNITY PARTICIPANT
          </Button>
          <Button
            variant="contained"
            color="warning"
            sx={{
              borderRadius: "50px",
              fontWeight: "bold",
              p: 2,
            }}
            onClick={handleShowInternationalTcModal}
          >
            BECOME AN INTERNATIONAL TC PARTICIPANT
          </Button>
        </Stack>

        <Stack spacing={3} pt={3}>
          <TechCommunitiesTable />
          <TechCommunitiesTable isInternational />
        </Stack>
      </Container>

      <BecomeUsTcForm show={showUsTcModal} setShowModal={setShowUsTcModal} />
      <BecomeInternationalTcForm
        show={showInternationalTcModal}
        setShowModal={setShowInternationalTcModal}
      />
    </>
  );
}
